import config from './config'
// import MultipleFileUploader from './MultipleFileUploader.vue'
const PDFObject = require('./pdfobject').default
// import xlsxImport from './xlsx-import.vue'
// import cvUpload from './cv-upload.vue'

export {
  config,
  //  MultipleFileUploader,
  PDFObject,
  // xlsxImport,
  //  cvUpload
}
